<template>
  <div class="forgetPassword">
    <Tab title="忘记密码"></Tab>
    <div class="operation">
      <div class="phone">
        <input type="text" placeholder="请输入手机号码" v-model="phone" />
      </div>
      <div class="code">
        <input
          type="number"
          @input="changeCode"
          v-model="code"
          placeholder="请输入验证码"
        />
        <div :class="countdown ? 'waitcode' : 'getcode'">
          <span v-if="!countdown" @click="getCode()">获取验证码</span>
          <span v-else>重新获取({{ second }}秒)</span>
        </div>
      </div>
      <div class="newPad">
        <input
          type="password"
          v-model="pwd"
          placeholder="新密码（不少于6位）"
        />
      </div>
      <div class="conPad">
        <input type="password" v-model="repwd" placeholder="确认密码" />
      </div>
      <button @click="confirm()">确定</button>
    </div>
  </div>
</template>

<script>
import Tab from "base/tab/tab";
import { getVerificationCode, changePwd } from "api/login";
// 检验输入密码是否一致，检验手机号，检验手机验证码
import { rePwdValid, mobileValid, captValid } from "common/js/util.js";
import Message from "base/message/message";

const message = new Message();

export default {
  data() {
    return {
      second: 60,
      countdown: false,
      phone: "", // 手机号码
      code: "", // 验证码
      pwd: "", // 密码
      repwd: "", // 确认密码
    };
  },
  methods: {
    changeCode() {
      if (this.code.length > 4) {
        this.code = this.code.slice(0, 4);
      }
    },
    // 获取验证码
    getCode() {
      let msg = mobileValid(this.phone);
      if (msg.err == 0) {
        getVerificationCode(this.phone).then((res) => {
          this.showCountdown();
        });
      } else {
        message.show(msg.msg);
      }
    },
    showCountdown() {
      this.countdown = true;
      let time = setInterval(() => {
        if (this.second == 0) {
          this.countdown = false;
          this.second = 60;
          clearInterval(time);
        } else {
          --this.second;
        }
      }, 1000);
    },
    confirm() {
      let msg1 = mobileValid(this.phone);
      let msg2 = captValid(this.code);
      if (msg2.err != 0 || msg1.err != 0) {
        message.show(msg1.msg || msg2.msg);
        return;
      }
      if (!this.pwd) {
        message.show("请输入密码");
        return;
      }
      if (this.pwd.length < 6) {
        message.show("密码不能小于六位数");
        return;
      }
      if (!this.repwd) {
        message.show("请输入确认密码");
        return;
      }
      if (this.pwd != this.repwd) {
        message.show("密码输入不一致");
        return;
      }
      let params = {
        mobile: this.phone,
        userKind: "S",
        smsCaptcha: this.code,
        loginPwd: this.pwd,
      };
      changePwd(params).then((res) => {
        message.show("修改成功");
        this.$router.push("/Login");
        if (code == "500") {
          message.show(errorMsg);
        }
      });
    },
  },
  components: {
    Tab,
  },
};
</script>

<style lang="scss" scoped>
.forgetPassword {
  padding-top: 100px;
  .operation {
    overflow: hidden;
    > div {
      margin: 10px 30px 0;
      height: 110px;
      line-height: 110px;
      font-size: 32px;
      box-shadow: 0px 1px 0px 0px rgba(227, 227, 227, 1);
      input {
        width: 100%;
        color: #333333;
      }
      &.code {
        display: flex;
        flex-direction: row;
        align-items: center;
        input {
          flex: 1;
        }
        .getcode {
          width: 168px;
          height: 52px;
          line-height: 52px;
          color: rgba(232, 64, 49, 1);
          border-radius: 26px;
          box-sizing: border-box;
          text-align: center;
          border: 2px solid rgba(232, 64, 49, 1);
          font-size: 25px;
        }
        .waitcode {
          width: 200px;
          height: 52px;
          text-align: center;
          line-height: 52px;
          background: rgba(204, 204, 204, 1);
          border-radius: 26px;
          color: #fff;
          font-size: 25px;
        }
      }
    }
    button {
      font-size: 32px;
      display: block;
      width: 690px;
      height: 90px;
      font-weight: 600;
      color: rgba(255, 255, 255, 1);
      background: rgba(232, 64, 49, 1);
      border-radius: 45px;
      text-align: center;
      margin: 0 auto 40px;
      margin-top: 100px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/login/forgetPassword.vue